import React from "react";
import Modal from "../../components/Modals/Modal";
import SecondaryButton from "../../components/Buttons/SecondaryButton";
import PrimaryButton from "../../components/Buttons/PrimaryButton";
import MultiFileInput from "../../components/Inputs/MultiFileInput";
import { MoonLoader } from "react-spinners";
import { COLORS, SCAN_TYPES } from "../../config";

function AddScanModal({
  showAddScan,
  closeModal,
  handleFileUpload,
  scanType,
  isFileUpload,
}) {
  const [formError, setFormError] = React.useState({
    field: "",
    msg: "",
  });

  const [files, setFiles] = React.useState(null);

  const handleFilesUpload = (e) => {
    setFormError({
      field: "",
      msg: "",
    });
    let error = false;
    setFiles(e.target.files);
  };

  const handleCancelAddScanFile = () => {
    if (!isFileUpload) {
      setFiles(null);
      setFormError({
        field: "",
        msg: "",
      });
      closeModal(false);
    }
  };

  const uploadFile = () => {
    if (!isFileUpload) {
      if (files && files.length) {
        handleFileUpload(files);
      } else {
        setFormError({
          field: "files",
          msg: "Please include a files to upload",
        });
      }
    }
  };

  let acceptType = [SCAN_TYPES.FACE_SCAN, SCAN_TYPES.INTRORAL_SCAN].includes(scanType)
    ? ".stl"
    : scanType === SCAN_TYPES.CBCT_SCAN
    ? ".dcm, .zip, .rar"
    : scanType === "Video"
    ? "video/mp4,video/x-m4v,video/*"
    : "image/*";

  return (
    <Modal
      title={"Upload Scan Files"}
      show={showAddScan}
      hide={handleCancelAddScanFile}
    >
      <div className="flex flex-col justify-between">
        <div className="flex flex-col items-center justify-around mt-8 mb-4">
          {formError.field === "files" && (
            <span className="text-red-400 text-sm">{formError.msg}</span>
          )}
          <MultiFileInput
            accept={acceptType}
            handleFileUpload={handleFilesUpload}
            buttonText="Select files"
          />
        </div>
        {files && Array.from(files).length > 5 ? (
          <div className={`ml-2 text-center text-primary`}>
            {Array.from(files).length} files selected
          </div>
        ) : (
          files &&
          Array.from(files).map((file) => {
            return (
              <div key={file.name} className={`ml-2 text-center text-primary`}>
                {file.name}
              </div>
            );
          })
        )}
        <div className="grid grid-cols-2 gap-x-2 mt-8">
          <SecondaryButton onClick={handleCancelAddScanFile} text="Cancel" />
          <PrimaryButton onClick={uploadFile} text="Upload" />
        </div>
        {isFileUpload && (
          <div className='flex absolute w-full ml-10' >
            <div className='rounded-lg shadow-xl flex justify-around min-h-170 pr-20 pl-20 items-center' style={{border: '1px solid lightgray', background: 'white'}}>
              <MoonLoader color={COLORS.colorPrimary}/>
             </div> 
          </div>
        )}
      </div>
    </Modal>
  );
}

export default AddScanModal;
